import React from 'react';
import colors from 'shared-components/theme/colors';
import { gilroyMedium } from 'shared-components/theme/fonts';
import Media from 'shared-components/theme/medias';
import styled from 'styled-components';
const SectionTitle = ({ tag, textColor }) => {
    return <SectionTag textColor={textColor}>{tag}</SectionTag>;
};

export default SectionTitle;

const SectionTag = styled.h4`
    color: ${(props) => props.textColor || colors.geoGreen[90]};
    text-transform: uppercase;
    font-family: ${gilroyMedium};
    font-size: 16px;
    font-weight: 500;
    ${Media('large')} {
        font-size: 0.952vw;
    }
    ${Media('mobile')} {
        font-size: 14px;
    }
`;
